module.exports = __webpack_public_path__ + "img/1551013268.ee552e8a.jpg";